import React from "react";
import { SEO, DynamicScript } from "@bluefin/components";
import { Grid, Segment } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";

export default class ShopPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const { fishermanBusiness, fishermanBusinessWebsitePage } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          title={fishermanBusinessWebsitePage.seoTitle}
          description={fishermanBusinessWebsitePage.description}
          ogUrl={"https://www.marktaylorsalon.com/shop/"}
        />
        <Grid
          className={"custom-page-shop custom-page-grid"}
          style={{}}
          stackable={true}
        >
          <Grid.Row
            className={"omemigbgfhhaenhh"}
            style={{ padding: 16 }}
            columns={1}
          >
            <Grid.Column className={"bcompjahpdoaedkj"} style={{ padding: 16 }}>
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <React.Fragment
                  key={"JSON__9b27881e-1fa3-44ed-a22f-98383e8958d8"}
                >
                  <div>
                    <div
                      id={"frameTitle"}
                      className={"embedded-widget-title"}
                    />
                    <div className={"vagaro"}>
                      <DynamicScript
                        src={
                          "https://www.vagaro.com//resources/WidgetEmbeddedLoader/OZqtCJ4vDoPqFJHy79oz34mC2PeFJ4mC30m9cyUeJUtjP0dDxkJEvwRapWUgZawifCs7fkJEPwMc8?v=VhNXMy1QlrF9mOZpqT2jGItkVmzo0ptPV3yqPaAh1f90#"
                        }
                      />
                    </div>
                    <div
                      id={"frameTitle"}
                      className={"embedded-widget-title"}
                    />
                    <div className={"vagaro"}>
                      <DynamicScript
                        src={
                          "https://www.vagaro.com//resources/WidgetEmbeddedLoader/OZqtCJ4vDoPqFJHy79oz34mC2PeFJ4mC30m9cyUeJUtjP0dDxkJEvwRapWUgZawifCs7fkJEPwMc8?v=VhNXMy1QlrF9mOZpqT2jGItkVmzo0ptPV3yqPaAh1f90#"
                        }
                      />
                    </div>
                  </div>
                </React.Fragment>
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
    }
    fishermanBusinessWebsitePage(_id: { eq: 38653 }) {
      title
      seoTitle
      description
    }
  }
`;
